/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectApplicationApproveDto
 */
export interface ProjectApplicationApproveDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicationApproveDto
     */
    applicationType: string;
}

/**
 * Check if a given object implements the ProjectApplicationApproveDto interface.
 */
export function instanceOfProjectApplicationApproveDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "applicationType" in value;

    return isInstance;
}

export function ProjectApplicationApproveDtoFromJSON(json: any): ProjectApplicationApproveDto {
    return ProjectApplicationApproveDtoFromJSONTyped(json, false);
}

export function ProjectApplicationApproveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectApplicationApproveDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applicationType': json['applicationType'],
    };
}

export function ProjectApplicationApproveDtoToJSON(value?: ProjectApplicationApproveDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applicationType': value.applicationType,
    };
}

